import { render, staticRenderFns } from "./TheHeaderDropdownAccount.vue?vue&type=template&id=bda74bc0&scoped=true&"
import script from "./TheHeaderDropdownAccount.vue?vue&type=script&lang=js&"
export * from "./TheHeaderDropdownAccount.vue?vue&type=script&lang=js&"
import style0 from "./TheHeaderDropdownAccount.vue?vue&type=style&index=0&id=bda74bc0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bda74bc0",
  null
  
)

export default component.exports